"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRectCenter = void 0;
function getRectCenter(rect) {
    return {
        top: rect.top + rect.height / 2,
        left: rect.left + rect.width / 2,
    };
}
exports.getRectCenter = getRectCenter;
